// 购买店铺
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box" @tab-click="handleClick">
      <el-tab-pane label="常规" name="first">
        <editView v-if="showEdit" visible-key="showEdit" :_dataId.sync="dataId" :parent-target="_self"
                  @reload="$reloadHandle" :initTableList="initTableList" @goBackIndex="goBackIndex"></editView>
      </el-tab-pane>
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">
          <vxe-grid :stripe="true" ref="table-m1" v-bind="gridData" show-overflow height="100%" border="default"
                    :row-config="{ isHover: true }"
                    @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">
            <template #form>
              <div class="clearfix screen-btns">
                <div class="fl">
                  <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                              @click="openEditDialog" v-if="buy_shop_add">新增
                  </vxe-button>
                </div>
                <div class="fr">
                  <!--                  <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text" status="primary"-->
                  <!--                    plain>重置</vxe-button>-->
                  <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                              @click="searchEvent">搜索
                  </vxe-button>
                </div>
              </div>
              <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="requestParam"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <vxe-form-item title="编码:" field="orderTypeName">
                  <template v-slot>
                    <el-input v-model="formData.shopCode" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="名称:" field="orderTypeName">
                  <template v-slot>
                    <el-input v-model="formData.shopName" size="small" clearable/>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="状态:" field="name">
                  <template v-slot>
                    <el-select v-model="formData.stat" size="small" clearable>
                      <el-option :value="1" label="可用"></el-option>
                      <el-option :value="2" label="不可用"></el-option>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item title="类型:" field="name">
                  <template v-slot>
                    <el-select v-model="formData.shopType" size="small" clearable>
                      <el-option :value="1" label="线上店铺"></el-option>
                      <el-option :value="2" label="线下店铺"></el-option>
                    </el-select>
                  </template>
                </vxe-form-item>
                <vxe-form-item :title="$t('common.ServiceProvider')+':'" field="name">
                  <template v-slot>
                    <site-search :site-id.sync="formData.siteId"  style="width:12vw ;" />
                  </template>
                </vxe-form-item>
              </vxe-form>
            </template>
            <template #option="{row}">
              <a href="javascript:void(0);" class="a-link" @click="openEditDialog(row.id)">
                <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                            popper-class="tooltip-skin">
                  <i class="el-icon-edit"/>
                </el-tooltip>
              </a>
              <el-dropdown @command="handleCommand($event, row)">
              <span class="el-dropdown-link">
                <i class="el-icon-arrow-down el-icon--right" style="color:#00c4b3"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="同意签约" v-if="row.isPddSign == 0">同意签约</el-dropdown-item>
                  <el-dropdown-item command="拒绝签约" v-if="row.isPddSign == 0">拒绝签约</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
            <template #pager class="pager_left">
              <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
            </template>
          </vxe-grid>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{dialogMsg}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmCheck">确 定</el-button>
        </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisibleReject"
      width="30%"
    >
      <span>{{dialogMsgReject}}</span>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibleReject = false">取 消</el-button>
          <el-button type="primary" @click="confirmReject">确 定</el-button>
        </span>
    </el-dialog>

  </div>
</template>

<script>
import editView from './edit.vue';
import {tableOption} from '@/const/crud/admin/tenant';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'
import {mapGetters} from "vuex";
import {indexPageMixins} from "@/mixins/tabChang";
import api from "@/api/projectApi";
import SiteSearch from "@/components/formItem/siteSearch.vue";
export default {
	name: 'source',
  mixins: [indexPageMixins],
  components: {SiteSearch,editView, pager},
  data() {
    return {
      buy_shop_add: false,
      buy_shop_edit: false,
      dialogMsg: null,
      dialogVisible: false,
      dialogMsgReject: null,
      dialogVisibleReject: false,
      total: 0,
      requestParam: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        siteId:null,
        shopName: null,
        shopCode: null,
        stat: null,
        shopType: null,
      },
      formData: {
        shopName: null,
        shopCode: null,
        stat: null,
        shopType: null,
        siteId:null,
        isPddSign:null,
      },
      pageSizes: [20, 50, 100],
      gridData: {},
      showEdit: false,
      activeName: 'second',
      dataId: 0,
      column: [
        {type: 'seq', title: '序号', width: 60, resizable: false, fixed: 'left'},
        {title: '编码', field: 'shopCode', width: 150,},
        {title: '名称', field: 'shopName', width: 150,},
        {title: '别名', field: 'otherShopName', width: 150,},
        {
          title: '类型', field: 'shopType', width: 80, slots: {
            default: ({row}) => {
              if (row.shopType == 1) {
                return [
                  <div>
                    <span>线上店铺</span>
                  </div>
                ];
              } else if (row.shopType == 2) {
                return [
                  <div>
                    <span>线下店铺</span>
                  </div>
                ];
              }
            }
          }
        },
        {
          title: ' 状态', field: 'stat', width: 100, slots: {
            default: ({row}) => {
              if (row.stat == 2) {
                return [
                  <div class="txt-status disable">
                    <span>不可用</span>
                  </div>
                ];
              } else if (row.stat == 1) {
                return [
                  <div class="txt-status">
                    <span>可用</span>
                  </div>
                ];
              }
            }
          }
        },
        {field: '', title: '地址', width: 300, slots: {default: ({row}) => {
              return [<div><span>{row.province}{row.city}{row.county}{row.town}</span></div>]
            }}
        },
        {field: 'siteName', title: '指定服务商', width: 150},
        {field: 'shopPhone', title: '联系方式', width: 150},
        {field: 'createTime', title: '创建时间', width: 150},
        {title: '创建人', field: 'modifyBy', width: 120,},
        { width: 100, fixed: 'right', title: '操作', sortable: false, slots: {default: 'option'}},
      ],

    };
  },
  // mounted() {
  //   this.orderTypeSave = this.permissions['order_type_add']
  // },
  created() {
    this.buy_shop_add = this.permissions['buy_shop_add']
    this.buy_shop_edit = this.permissions['buy_shop_edit']
  },
  computed: {
    ...mapGetters(["permissions"])
  },
  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }

  },
  methods: {

    // 操作
    handleCommand(command, row) {
      this.currentRowId = row.id
      console.log(command, row, "command,b的值");
      if (command === '同意签约') {
        this.dialogMsg = '确定同意拼多多签约吗?'
        this.dialogVisible = true
      } else if (command === '拒绝签约') {
        this.dialogMsgReject = '确定拒绝拼多多签约吗?'
        this.dialogVisibleReject = true
      }
    },

    //同意签约
    confirmCheck() {
      this.$http({
        url: api.basBuyShop.pddSignAcceptUrl,
        method: 'post',
        data: {
          id: this.currentRowId,
        }
      }).then(res => {
        this.$message.success('回传成功')
        this.flushed()
      })
      this.dialogVisible = false
    },

    //拒绝签约
    confirmReject() {
      this.$http({
        url: api.basBuyShop.pddSignRejectUrl,
        method: 'post',
        data: {
          id: this.currentRowId,
        }
      }).then(res => {
        this.$message.success('回传成功')
        this.flushed()
      })
      this.dialogVisibleReject = false
    },

    toFilterData() {
          // console.log(55,"触发了搜索");
    // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
        if(this.formData === '') {
             return
        } else {
        // 请求查询接口，将列表展现出来
            this.searchEvent();
         }
     },

    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    // 加载table数据
    getTableData() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        path: api.basBuyShop.getTableDataUrl,
        param: this.requestParam,
        method: 'post',
        columns: this.column
      };
      this.gridData = initVxeTable(tableOption);
      this.flushed()
    },

    // 分页功能
    changeTablePage(page, flag) {
      this.requestParam.size = page.pageSize
      this.requestParam.current = page.currentPage
      this.requestParam.searchCount = flag
      this.getTableData()
    },

    handleClick(tab, event) {
      console.log(tab, event, 'handleClick');
      this.flushed()
    },

    updateChange() {
      this.flushed()
    },

    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.requestParam.current = 1
      this.requestParam.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // // 重置
    // resetEvent() {
    //   this.searchValue = ''
    //   this.requestParam.searchCount = false
    //   this.requestParam.current = 1
    //   this.requestParam.orderTypeName = ''
    //   this.$refs.pager.reset()  // 重置分页器
    //   this.flushed()
    // },
    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
  }
};
</script>


<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.pager_left {
  margin-left: 1px;
}
</style>
